import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'gsp-toast-banner-information',
  templateUrl: './toast-banner-information.component.html',
  styleUrls: ['./toast-banner-information.component.scss']
})
export class ToastBannerInformationComponent implements OnInit {
  @Input() headerText: string;
  @Input() subHeaderText: string;
  ngOnInit() { }
}